module.exports = {
  format: {
    date: "DD/MM/YYYY",
    dateHour: "DD/MM/YYYY HH:mm",
  },
  login: {
    welcomeDev: "VOXGODev",
    welcome: "VOXGO",
    access: "Acessar",
    accessCompany: "Acessar",
    errorCompany: "Nenhuma empresa associada a esse email",
    login: "Entrar",
    goReset: "Esqueci minha senha",
    goLogin: "Retornar ao login",
    accessClient: "Acesso Cliente",
    accessAdmin: "Acesso Admin",
    facebook: "Entrar com Facebook",
    google: "Entrar com Google",
    apple: "Entrar com Apple",
    phone: "Entrar com Telefone",
    facebookRegister: "Cadastro com Facebook",
    googleRegister: "Cadastro com Google",
    appleRegister: "Cadastro com Apple",
    phoneRegister: "Cadastro com Telefone",
    emailRegister: "Cadastro com Email",
    getPhoneNumber: "Insira seu número de telefone",
    getPhoneCode: "Insira seu código de verificação enviado ao seu celular",
    resetCompany: "Resetar Senha",
    reset: "Enviar email",
    error: {
      generic: "Houve algum erro ao efetuar login",
      phoneEmpty: "Número de telefone vazio",
      phoneCodeEmpty: "Código de verificação vazio",
      loginTitle: "Erro ao efetuar login",
      changePasswordTitle: 'Erro ao alterar a senha',
      providerTitle: "Erro ao adicionar provider",
      resetNotFound: 'Reset de senha não encontrado',
      accessDenied: 'Acesso negado',
    },
    providerCode: {
      "auth/invalid-email": "Email inválido",
      "auth/user-disabled": "Conta desabilitada",
      "auth/user-not-found": "Usuário não encontrado",
      "auth/email-not-found": "Email não encontrado no Firebase Auth usado na validação",
      "auth/wrong-password": "Senha incorreta",
      "auth/invalid-login-credentials": "Email ou senha incorretos",
      "auth/credential-already-in-use": "Credencial já utilizada",
      "auth/email-already-exists": "Email já utilizado",
      "auth/too-many-requests": "Muitas tentativas, tente novamente mais tarde",
      "auth/operation-not-allowed": "Tipo de login não configurado, tente outra forma de login",
      "auth/network-request-failed": "Parece que você não está conectado na internet",
      "auth/invalid-password": "Senha inválida",
      "auth/missing-email": "Email do usuário não encontrado",
      "auth/email-mismatch": "Email do Firebase Auth não confere com o usuário",
      "auth/password-provider-not-enabled": "Login por senha não habilitado para este usuário",
      "auth/password-verification-failed": "A senha foi enviada, mas o login de validação falhou",
      "auth/uid-mismatch": "A validação da senha retornou outro usuário",
      "auth/api-key-invalid": "API key do Firebase inválida para validar o login",
      missingEmail: "O email é necessário",
      missingPassword: "A senha é necessária",
      internal: "Erro interno",
      notFound: "Esse usuário não existe"
    },
    addFacebook: "Adicionar Facebook",
    addGoogle: "Adicionar Google",
    addApple: "Adicionar Apple",
    providers: "Métodos de autenticação",
    remove: "Remover",
    providerId: "Provider",
    email: "E-mail",
    uid: "uid",
    changePassword: "Alterar senha",
    addPassword: "Adicionar Senha",
    resetClient: "Resetar senha",
    register: "Registrar",
    registerClient: "Registrar",
    resetPassword: "Resetar senha",
    makeRegister: "Efetuar cadastro",
    title: "Entrar",
    password: "Senha",
    copyright: "© VOXGO",
    choseAnotherPassword: 'Escolha uma nova senha',
    resetSuccess: 'Senha alterada com sucesso',
    userAssociated: 'Usuário existente associado a essa empresa, a senha dele é a senha previamente cadastrada',
    welcomeClient: 'Bem vindo ao VOXGO',
    welcomeAdmin: 'Bem vindo ao VOXGO Admin',
    welcomeClientDev: 'VOXGO, área de desenvolvimento',
    welcomeAdminDev: 'VOXGO Admin, área de desenvolvimento',
    goLoginAdmin: 'Acesso Admin',
    goLoginClient: 'Acesso',
  },
  all: {
    bioVOXGO: 'Bio VOXGO',
    notifications: 'Notificações',
    events: 'Eventos',
    tags: 'Tags',
    reportsEvents: 'Eventos reportados',
    reportsUsers: 'Usuários reportados',
    about: 'Sobre',
    faqs: 'Faq',
    faqsCategories: 'Categorias de Faq',
    access: 'Acessos',
    dashboard: "Dashboard",
    adminUsers: "Usuários admin",
    users: "Usuários",
    publicity: "Publicidade",
    card: "Card",
    versionNav: "VOXGO",
    genres: "Gêneros",
    goBack: "Voltar",
    configs: "Configurações",
    services: "Serviços",
    logout: "Sair",
    switchDarkTheme: "Modo escuro",
    switchLanguage: "Idioma",
    profile: "Perfil",
    posts: "Box Oficial",
    voxSpot: "VoxSpot",
    voxPoint: "VoxPoint",
    popVox: "PopVOX",
  },
  dashboard: require('./dashboard/pt-BR.js'),
  voxPoint: {
    addTitle: "Adicionar VoxPoint",
    editTitle: "Editar VoxPoint",
    status: "Estado",
    username: "Usuário",
    dateStart: "Início",
    dateEnd: "Fim",
    actions: "Ações",
    address: "Morada",
    number: "Número",
    postalCode: "Código postal",
    hintNoNumber: "Sem número — será usado o centro do código postal",
    files: "Arquivos",
    addFile: "Adicionar arquivo",
    replaceFile: "Substituir arquivo",
    fileName: "Nome",
    usernameChecking: "Verificando...",
    usernameFound: "Usuário encontrado",
    usernameNotFound: "Nenhum usuário encontrado com este username",
    usernameAlreadyVoxPoint: "Este usuário já está registado como VoxPoint",
    activateTitle: "Ativar VoxPoint",
    deactivateTitle: "Inativar VoxPoint",
    activatedSuccess: "Usuário @{username} ativado como VoxPoint",
    deactivatedSuccess: "Usuário @{username} inativado como VoxPoint",
    errorUserRequired: "Selecione um usuário válido antes de guardar.",
    errorDateEndBeforeStart: "A data de Fim não pode ser anterior à data de Início.",
    errorUserDeleted: "Este usuário foi excluído e não pode ter o VoxPoint ativado.",
    deleteConfirm: "Excluir o VoxPoint de @{username}? Ele sai da lista de VoxPoints e do mapa; a conta do usuário não é apagada.",
    deletedSuccess: "VoxPoint de @{username} excluído",
  },
  voxSpot: {
    estado: "Estado",
    dateStart: "Início",
    dateEnd: "Fim",
    locations: "Localizações",
    actions: "Ações",
    logo: "Ícone do mapa",
    address: "Morada",
    number: "Número",
    postalCode: "Código postal",
    importExcel: "Importar localizações via Excel",
    addLocation: "Adicionar localização",
    errorReadingExcel: "Erro ao ler ficheiro Excel",
    errorInvalidTemplate: "Ficheiro fora do template esperado. Verifique se as colunas Cidade, Nome da Rua, Número da Porta e Código Postal estão presentes.",
    errorEmptyFile: "Nenhuma localização encontrada no ficheiro.",
    errorIncompleteLocation: "Todas as localizações devem ter Morada e Código Postal preenchidos.",
    errorDuplicateLocation: "Existem localizações duplicadas. Por favor, remova as repetidas antes de guardar.",
    errorAllDuplicates: "Nenhuma localização foi adicionada pois todas já existiam.",
    warnSkippedDuplicates: "{count} ignorada(s) por duplicado",
    warnSkippedIncomplete: "{count} ignorada(s) por endereço incompleto (Morada ou Código Postal em falta)",
    hintNoNumber: "Sem número — será usado o centro do código postal",
    errorDateEndBeforeStart: "A data de Fim não pode ser anterior à data de Início.",
    noLocations: "Sem localizações",
    deactivateTitle: "Inativar VoxSpot",
    deactivatedSuccess: "VoxSpot {name} inativado",
    deleteConfirm: "Excluir o VoxSpot {name}? Ele sai da lista de VoxSpots e do mapa. Esta ação não pode ser desfeita.",
    deletedSuccess: "VoxSpot {name} excluído",
  },
  users: {
    list: {
      loadError: "Não foi possível carregar os usuários.",
      retry: "Tentar novamente",
      textSortHint: "Para ordenar por nome, username ou e-mail, faça uma busca ou aplique um filtro.",
    },
    bulkImport: {
      buttonTitle: "Importar usuários via planilha",
      linkFromCreateForm: "Importar via planilha",
      title: "Importar usuários via planilha",
      instructions: "Selecione um ficheiro Excel (.xlsx) com a primeira linha contendo os cabeçalhos das colunas:",
      profilePicture: "Foto de perfil (opcional, aplicada a todos os usuários da planilha)",
      selectFile: "Selecionar ficheiro Excel",
      errorReadingExcel: "Erro ao ler ficheiro Excel",
      errorInvalidTemplate: "Ficheiro fora do template esperado. Verifique se as colunas NOME, USERNAME, E-MAIL e SENHA estão presentes.",
      errorEmptyFile: "Nenhum usuário encontrado no ficheiro.",
      errorMissingFieldsList: "Campos obrigatórios em falta nesta linha: {fields}",
      errorInvalidBirthDate: "Data de nascimento inválida ou em falta",
      processing: "Processando {current} de {total}...",
      summary: "{success} de {total} usuários criados com sucesso. No primeiro login, os usuários devem ser direcionados a criar uma nova senha.",
      colPassword: "Senha",
      colStatus: "Status",
      statusSuccess: "Criado",
      addressNotResolved: "Cidade não localizada automaticamente — edite o usuário para definir o endereço",
      imageUploadFailed: "Falha ao aplicar a foto de perfil — tente novamente pela edição do usuário",
      copyPassword: "Copiar senha",
      passwordCopied: "Senha copiada",
    },
    details: {
      birthDate: "Nascimento",
      gender: "Gênero",
      location: "Cidade",
      createdAt: "Criado em",
      notInformed: "Não informado",
    },
  },
  popVox: {
    title: "PopVOX",
    image: "Banner do PopVOX",
    placement: "Exibição",
    placementMap: "MAP",
    impactRule: "Quantidade de impactos em 24h",
    impactRuleHint: "Número máximo de vezes que o banner pode ser exibido ao mesmo usuário dentro de 24 horas",
    linkUrl: "URL do Link (Opcional)",
  },
  appConfig: {
    publicMapTitle: "Mapa sem login",
    publicMapEnabled: "Ativar mapa sem login",
    endpoint: "Endpoint para Android/iOS",
    errorLoad: "Erro ao carregar configuraÃ§Ãµes",
    suggestedUsersTitle: "Sugestões de utilizadores (Find)",
    suggestedUsersRadiusKm: "Raio de sugestão (km)",
    suggestedUsersRadiusKmHint: "Distância ao redor da localização do utilizador usada para sugerir boxes/perfis no Find",
  },
  form: {
    saveAndSendNotification: 'Salvar e enviar notificação',
    countEvents: 'Eventos',
    countComments: 'Comentários',
    countFollows: 'Conexões',
    createdBy: 'Criado por',
    events: 'Eventos',
    eventDateBegin: 'Do dia',
    eventDateEnd: 'Até o dia',
    begin: 'início',
    end: 'fim',
    reportedAt: 'Reportado em',
    reportedBy: 'Reportado por',
    all: 'Todos',
    status: 'Status',
    reportStatus: 'Status',
    isBlocked: 'Bloqueado',
    blocked: 'Bloqueado',
    notBlocked: '',
    body: 'Texto',
    date: 'Data',
    birthDateBegin: 'Nascimento de',
    birthDateEnd: 'Nascimento até',
    createdAtBegin: 'Criado de',
    createdAtEnd: 'Criado até',
    views: "Visualizações",
    uniqueViews: "Visualizações únicas",
    hits: "Vídeos",
    selectVideo: "Selecione o vídeo",
    userPlan: "Plano",
    emailAdmin: "Email administrador",
    userAdmin: "Nome administrador",
    tradeName: "Razão social",
    momName: "Nome da mãe",
    hasCPF: "Tem CPF?",
    type: 'Tipo',
    genderText: 'Gênero',
    gender: {
      male: "Masculino",
      female: "Feminino",
      other: "Outro",
    },
    tellTheSex: "Informe o sexo",
    select: "Selecione",
    birthDate: "Data de nascimento",
    profilePicture: "Foto de perfil",
    checking: "Verificando...",
    available: "Disponível",
    usernameNotAvailable: "Este nome de usuário não está disponível.",
    error: {
      invalidCPF: "CPF  inválido",
      justNumbers: "Digite apenas números",
      required: "Esse campo é requerido",
      minLength: "O campo é muito curto",
      maxLength: "O campo é muito longo",
      update: "Houve algum erro",
      email: "Email inválido",
      image: {
        type: "Tipo de arquivo inválido, esperado: PNG, JPEG",
        upload: "Erro ao fazer ulpload da imagem, tente novamente mais tarde!"
      },
      invalidValue: "Entrada inválida",
      formInvalid: "Campo inválido",
      uploadImage: "Erro ao fazer upload de imagem",
      closeEditor: "Conclua ou cancele o editor antes de proseguir",
      showOnMenu: "Mostrar no menu",
      regionAreaName: "Erro ao obter nome da área da região",
      NeedRegion: "É necessário definir uma região",
      changeOnlyAdmin: "Entre em contato com o suporte para efetuar essa ação",
      passwordRequired: "A senha é necessária",
      emailRequired: "O email é necessário",
      createUser: 'Erro ao criar autenticação do usuário',
      changePassword: 'Erro ao alterar senha do usuário',
      changeEmail: 'Erro ao alterar email do usuário',
      changeActive: 'Erro ao alterar o estado ativo/inativo do usuário',
      authActiveOutOfSync: 'O estado ativo/inativo deste usuário não foi aplicado no login. Grave de novo para tentar outra vez.',
      cpfInvalid: 'CPF inválido',
      cpfExist: 'O CPF já existe',
      cpfError: 'Erro ao validar o cpf',
      copiedToClipboard: 'Falha ao copiar para o Clip Board',
      passwordConfirmError: 'As senhas são diferentes',
      passwordTryChange: 'Erro ao tentar alterar a senha',
      uploadError: 'Erro ao fazer upload',
      uploadErrorContinueAsk: 'Deseja salvar o evento sem fazer o upload?',
      isMatrizLocked: 'Só é possível alterar essa flag na criação',
      minAge: 'É necessário ter no mínimo 18 anos',
      usernameMinLength: 'Mínimo de 4 caracteres.',
      usernameInvalid: 'Username inválido.',
      checkAvailabilityError: 'Não foi possível verificar disponibilidade agora',
    },
    update: "Atualizar",
    updateSuccess: "Dados salvos",
    email: "Email",
    password: "Senha",
    currentPassword:'Senha antiga',
    newPassword: 'Nova senha',
    passwordConfirmation:'Confirmação da nova senha',
    continue: "Continuar",
    cnpj: "CNPJ",
    cpf: "CPF",
    name: "Nome",
    prevStep: "Etapa Anterior",
    nextStep: "Próxima etapa",
    conclude: "Concluir",
    close: "Fechar",
    cancel: "Cancelar",
    changePrimaryColor: "Alterar cor primária",
    changeSecondaryColor: "Alterar cor secundária",
    emailResetSuccess: "Em instantes você receberá um email para redefinir a sua senha",
    emailResetError: "Houve um erro ao tentar enviar email de redefinição de senha",
    changePassword: "Alterar Senha",
    passwordNew: "Nova Senha",
    passwordOld: "Senha atual",
    address: {
      city: "Cidade",
      complement: "Complemento",
      country: "Pais",
      district: "Bairro",
      number: "Número",
      search: "Buscar Endereço",
      searchCity: "Buscar cidade",
      state: "Estado",
      street: "Rua",
      zipcode: "CEP",
      fieldWarning: "Erro ao buscar endereço",
      emptyResult: "Nenhum endereço encontrado"
    },
    contact: "Contato",
    description: "Descrição",
    phone: "Telefone",
    contactPhone: "Telefone para contato",
    delete: "Deletar",
    confirmDelete: "Tem certeza que deseja deletar?",
    edit: "Editar",
    add: "Adicionar",
    permission: "Permissão",
    active: "Ativo",
    inactive: "Inativo",
    isActive: 'Ativo?',
    create: "Criar",
    isLiquid: "É líquido",
    isMandatory: "Obrigatório",
    numberOfChoices: "Máximo de escolhas (0 sem limite)",
    print: "Imprimir",
    showIds: "Mostrar Ids",
    visible: "Visísvel",
    required: "Obrigatório",
    nutritionalUnit: "Unidade de medida",
    showOnMenu: "Mostrar no menu",
    isCash: "É dinheiro?",
    getDeliveryAreaName: "Nome da área de entrega",
    getRegionName: "Nome da área da região",
    isProduct: "Aplicável em produtos",
    isCompany: "Aplicável em empresas",
    isRestrictions: "É Restrição Alimentar",
    uniqueName: "Identificador único",
    slug: "Slug(url)",
    title: "Título",
    subTitle: "Legenda",
    bodyText: "Texto",
    abstract: "Resumo",
    response: "Resposta",
    category: "Categoria",
    approved: "Aprovado",
    isAdvanced: "Edição avançada",
    alert: {
      emailAddSuccess: "Email adicionado com sucesso",
      hasChangesPending: "Há alterações pendentes, Tem certeza que deseja fechar?",
      deleteUser: "Remover o usuário?",
      deleteEvent: "Remover o evento?",
      confirmSenNotification: "Enviar notificações?"
    },
    region: "Região",
    isTest: "Mostrar em teste",
    isNew: "Restaurante novo",
    regionAll: "Todas as Regiões",
    selectUser: "Selecione o usuário",
    selectUsers: "Selecione os usuários",
    selectCompany: "Selecione a empresa",
    selectCompanies: "Selecione as empresas",
    selectProduct: "Selecione o produto",
    selectProducts: "Selecione os produtos",
    link: "Link",
    selectUsersOrderNotifications1: "Usuários notificados em pedidos atrasados em 5 min",
    selectUsersOrderNotifications2: "Usuários notificados em pedidos atrasados em 10 min",
    deliveryHubDenied: "Bloquear delivery nessa região?",
    regionAreaInfo: "Área para BLOQUEAR recebimento de pedidos para ENTREGA",
    search: "Buscar",
    color: "Cor",
    createdAt: "Criado em",
    selectRules: 'Selecione os acessos',
    promptQuestion: "",
    confirmQuestion: "Você tem certeza?",
    confirmQuestionYes: "Sim",
    confirmQuestionCancel: "Cancelar",
    choseNewPassword: "Escolha uma nova senha",
    fixUserAuth: "Corrigir Auth do usuário",
    rules: "Acessos",
    crm: "CRM",
    isAnesthetist: 'É anestesista',
    copiedToClipboard: 'Url copiada para o clipboard',
    accessCompany: "Acessar empresa",
    isMatriz: 'É Matriz? (Utilizado para cooperativa, não pode ser alterado depois de criada a empresa)',
    isFilial: 'É filial?',
    matrizName: 'Empresa matriz',
    next: 'Próximo',
    linkUser: 'Vincular o usuário {user} na empresa {company}',
    removeFromCompany: 'Remover da empresa',
    removeFromCompanyConfirm: 'Tem certeza que deseja desvicular o usuário da empresa?',
    selectAccess: 'Selecione os acessos do usuário nessa empresa',
    addProcedure: 'Adicionar procedimento',
    username: 'Username',
  },
  image: {
    crop: "Crop",
    zoomIn: "Zoom In",
    zoomOut: "Zoom Out",
    rotateLeft: "Girar Esquerda",
    rotateRight: "Girar Direita",
    mirrorY: "Espelhar Y",
    mirrorX: "Espelhar X",
    show: "Mostrar Imagem",
    remove: "Deletar Imagem",
    selectNewFile: "Selecionar um novo arquivo"
  },
  access: {
    title: "Acesso",
    admin: "Administrador",
    user: "Usuário",
  },
  tools: {
    title: "Ferramenta"
  },
  rules: {
    adm: {
      adm: "Administrador",
      sup: "Suporte"
    },
  },
  router: {
    accessDenied: "Acesso Negado",
  },
  emailReset: {
    subject: "Resetar senha",
    head: "Recebemos uma solicitação para redefinir sua senha do VOXGO,\n acesse o link abaixo para definir uma nova senha",
    body: "",
    link: "Resetar senha",
    hello: 'Olá',
  },
  blog: {
    title: "",
    notFound: "Post Não Encontrado"
  },
  page: {
    title: "",
    notFound: "Página Não Encontrado"
  },
  inputError: {
    name: "Preencha o nome",
    companyName: "Preencha o nome da empresa",
    cnpj: "Preencha o cnpj",
    priceRange: "Preencha o intervalo de valor",
    businessType: "Preencha o tipo de negócio",
    completeAddress: "Termine de preencher o endereço",
    completeBank: "Termine de preencher as informações bancárias",
    phone: "Preencha o telefone",
    previousSend: "Enviado anteriormente",
    needCanReceive: "É necessário ter a conta de pagamento aprovada"
  },
  paginate: {
    prev: "Prev",
    next: "Next"
  },
  _404: {
    notFoundHeader: "Página não encontrada, tente recarregar a página.",
    timeout: "A página atingiu o tempo limite durante o carregamento. Tem certeza de que ainda está conectado à Internet?"
  },
  jobs: {
    type: "Tipo",
    name: "Nome",
    arg: "argumentos"
  },
  apiErrorCode: {
    otherUser: "O usuário não tem permissão para alterar a senha de outro.",
    statusError: "Estado inválido",
    permissionDenied: "O usuário não tem permissão para executar essa ação",
    unknown: "Erro desconhecido",
    paymentError: "Erro ao efetuar o pagamento",
    inputError: "Erro nos parâmetros",
    exhaustedAttempts: "Muitas tentativas",
    paymentInvalidValue: "Valor de pagamento inválido",
    notFound: "Não encontrado",
    OK: "Sucesso",
    previously: "Já feito anteriormente",
    emailAlreadyExists: "Este email já está em uso",
    emailInvalid: "Email inválido",
    usernameAlreadyExists: "Este nome de usuário já está em uso"
  },
  FcmComponents: {
    name: 'Nome',
    search: 'Buscar',
    save: 'Salvar',
    conclude: 'Concluir',
    selected: 'Selecionado',
    selecteds: 'Selecionados',
    confirmButton:'Confirmar',
    warn: {
      noSave: 'Você fechou o form sem salvar os dados'
    }
  },
  statesSigla: {
    '--': 'Estrangeiro',
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SE: 'Sergipe',
    SP: 'São Paulo',
    TO: 'Tocantins',
  },
  fcm: {
    errors: {
      fileTypeNotAllowed: 'Typo de Arquivo não permitido',
      fileNotWillBeUpload: 'Não vai ser feito o upload do arquivo por causa de um erro com o arquivo',
      needFolder: 'É necessário definir um folder',
    },
    confirmDelete: 'Você tem certeza que deseja remover esse arquivo?',
    needUploadToServerToSeeInTab: 'É necessário concluir antes de abrir em nova aba',
  },
  PublicityType: {
    KRadar: "Radar",
    KEvent: "Evento",
    KSearch: "Buscador",
    PopVOX: "PopVOX",
  },
  publicityRefType: {
    none: "Nenhum",
    link: "Link",
  },
  api: {
    chamadaFooter: 'Baixe o VOXGO GRÁTIS e venha fazer parte da maior virada da música de todos os tempos!',
    soBaixar: 'É SÓ BAIXAR!',
    interprete: "Interprete",
    compositor: "Compositor",
    browseUpgrade: "Você está usando um navegador <strong>antigo</strong>. Por favor <a href=https://browsehappy.com/'>atualize seu navegador</a> para melhorar sua experiência e segurança.",
    home: "Home",
    contato: "Contato",
    studioPlateia: "Conectados",
    studioBastidores: "Conectou-se",
    studioBiografia: "Biografia",
    studioAgenda: "Agenda",
    studioContato: "Contato",
    studioDownloadChamada: "Clique P/ Baixar",
    studioConnections: "Conexões"
  },
  notification: {
    type: {
      POST: "Notificação vinculada ao box oficial {title}",
      EVENT: "Notificação vinculada ao evento {title}",
      USER: "Notificação vinculada ao usuário {title}",
    },
    sendToType: {
      title: "Enviar para",
      region: "Região",
      selected: "Usuários selecionados",
      all: "Todos"
    },
    search: {
      search: "Termo da busca"
    },
    follow: {
      body: " se conectou com você",
      title: "Nova conexão"
    },
    markIGo: {
      body: " vai no seu evento",
      title: "Novo participante"
    },
    diclosure: {
      body: " está anunciando o seu evento",
      title: "Novo anunciante"
    }
  },
  interactionsTitle: {
    NEW_FOLLOWER: "NOVA CONEXÃO",

    KEventNew: "NOVO EVENTO",
    KEventChange: "ALTERAÇÃO DO EVENTO",
    KEventCanceled: "CANCELAMENTO DO EVENTO",
    NEW_DISCLOSURE_TO_FOLLOWER: "DIVULGAÇÃO",
    NEW_DISCLOSURE: "DIVULGAÇÃO",

    NEW_I_GO: "EU VOU",
    KEventReActive: "EVENTO REATIVADO",

    KEventPrivateInvite: "CONVITE PARA EVENTO",
    KEventMention: "NOVA MENÇÃO",
    KEventComment: "NOVO COMENTÁRIO",
    KEventCommentReply: "NOVA RESPOSTA",
  },
  interactionsBody: {
    NEW_FOLLOWER: "@{username} está conectado a você",
    // KPlaylistFollow: "Segue sua playlist!",
    // KPlaylistCloned: "Clonou a sua playlist",
    KEventNew: "@{username} criou um novo evento {eventTitle}.",
    KEventChange: "{eventTitle} foi modificado pelo @{username}.",
    KEventCanceled: "O evento {eventTitle} foi cancelado - motivo: {cancelledReason}.",
    NEW_DISCLOSURE_TO_FOLLOWER: "@{username} está divulgando o evento {eventTitle}.",

    NEW_DISCLOSURE: "@{username} está divulgando o seu evento {eventTitle}.",
    NEW_I_GO: "@{username} confirmou presença no seu evento {eventTitle}.",
    // KEventReActive: "{eventTitle} foi descancelado pelo @{username}."
    KEventReActive: "O evento {eventTitle} foi reativado",

    KEventPrivateInvite: "Você foi convidado para o evento {eventTitle}",
    KEventMention: "@{username} mencionou você no evento {eventTitle}",
    KEventComment: "@{username} comentou no seu evento {eventTitle}",
    KEventCommentReply: "@{username} respondeu ao seu comentário no evento {eventTitle}",
  },
  ReportStatus: {
    REPORTED: 'Pendente',
    ACCEPTED: 'Aceito',
    REJECTED: 'Recusado'
  },
  NotificationManualType: {
    NONE: 'Normal',
    USER: 'Usuário',
    EVENT: 'Evento'
  },
  NotificationManualStatus: {
    PENDING: 'Pendente',
    SEND: 'Enviado',
    SENDING: 'Enviando',
    ERROR: 'Erro'
  },
  SendTo: {
    ALL: 'TODOS',
    SEARCH: 'Busca',
    USERS: 'Usuários',
  }
};



